// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_template_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowTemplateService } from "./workflow_template_service_pb";

/**
 * ListWorkflowTemplates returns all workflow templates for the authenticated
 * organization, sorted by display_order ascending, then section business
 * order (単日 → 週間 → 月間 → 年間), then name ascending.
 * Legacy 当日 / 翌日 / 翌々日 share the 単日 rank.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.ListWorkflowTemplates
 */
export const listWorkflowTemplates = WorkflowTemplateService.method.listWorkflowTemplates;

/**
 * GetWorkflowTemplate returns the full detail of a single workflow template
 * identified by id.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.GetWorkflowTemplate
 */
export const getWorkflowTemplate = WorkflowTemplateService.method.getWorkflowTemplate;

/**
 * CreateWorkflowTemplate creates a new workflow template and returns the
 * full detail of the created record.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.CreateWorkflowTemplate
 */
export const createWorkflowTemplate = WorkflowTemplateService.method.createWorkflowTemplate;

/**
 * UpdateWorkflowTemplate performs a full replacement (PUT semantics) of the
 * workflow template identified by id. Uses optimistic locking via
 * expected_updated_at.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.UpdateWorkflowTemplate
 */
export const updateWorkflowTemplate = WorkflowTemplateService.method.updateWorkflowTemplate;

/**
 * DeleteWorkflowTemplate deletes the workflow template identified by id.
 * Uses optimistic locking via expected_updated_at.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.DeleteWorkflowTemplate
 */
export const deleteWorkflowTemplate = WorkflowTemplateService.method.deleteWorkflowTemplate;

/**
 * UpdateWorkflowTemplateDisplayOrder renumbers the display_order values of
 * all visible workflow templates to match the supplied full ordered list of
 * template ids. The caller must supply every visible template id exactly once.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.UpdateWorkflowTemplateDisplayOrder
 */
export const updateWorkflowTemplateDisplayOrder = WorkflowTemplateService.method.updateWorkflowTemplateDisplayOrder;

/**
 * GetWorkflowTemplateFormOptions returns the 3 form-option masters the
 * template editor (新規/編集/複製) needs: members (担当者 select 候補),
 * tag_pool (「作成済のタグ」再利用サジェスト + 20 個上限事前チェック), and
 * approval_processes (承認フローバッジ算出用). Read-only BFF aggregation
 * that fans out to backend UserDirectoryService.ListMembers,
 * WorkflowCaseService.ListWorkflowTagPool, and
 * ApprovalFlowService.GetApprovalFlowSettings.
 *
 * @generated from rpc bffuser.v1.WorkflowTemplateService.GetWorkflowTemplateFormOptions
 */
export const getWorkflowTemplateFormOptions = WorkflowTemplateService.method.getWorkflowTemplateFormOptions;
